import getCustomGlobalStylesRootRule from './get-custom-global-styles-root-rule';
import { connectedStore } from '../../store';
import globals from '../../globals';
import constants from '../constants';
import template from '../../template';
import hdrm from '../../hdrm';
import view from '../../view';
import {
  UPDATE_LIVE_ONLY,
  UPDATE_STATIC_ONLY,
  UPDATE_BOTH,
} from '../../hdrm/constants/update-strategies';

const { GLOBAL_STYLES_VARIABLE } = constants;
const BEFORE_END = 'beforeend';

const stringifyCssVariables = (cssVariables) =>
  Object.entries(cssVariables)
    .map(([key, value]) => `${key}: ${value};`)
    .join(' ');

const createCustomGlobalStyleElement = (id, variables) => {
  const styleElement = document.createElement('style');
  const styleWrapper = document.createElement('div');

  styleElement.innerHTML = `:root { ${stringifyCssVariables(variables)} }`;
  styleWrapper.appendChild(styleElement);
  styleWrapper.setAttribute('id', id);

  return styleWrapper;
};

const updateLiveCssVariables = (headerCodeGlobal, id, cssVariables) => {
  const rootRule = getCustomGlobalStylesRootRule();

  if (!rootRule) {
    const liveDom = view.accessors.getLiveDocument();
    const liveHeaderCodeGlobalNode = liveDom.querySelector(
      `ws-global[src*="${headerCodeGlobal.source}"]`
    );
    const elementId = view.accessors.getLiveElementId(liveHeaderCodeGlobalNode.firstElementChild);
    const styleWrapper = createCustomGlobalStyleElement(id, cssVariables);

    hdrm.operations.insertElement(styleWrapper, elementId, BEFORE_END, UPDATE_LIVE_ONLY);

    return;
  }

  Object.entries(cssVariables).forEach(([key, value]) => {
    rootRule.style.setProperty(key, value);
  });
};

const updateStaticCssVariables = (globalId, id, cssVariables) =>
  globals.operations.changeGlobalContent(
    globalId,
    (globalFragment) => {
      const styleElement = globalFragment.querySelector(`#${id} style`);

      if (!styleElement) {
        const styleWrapper = createCustomGlobalStyleElement(id, cssVariables);

        globalFragment.appendChild(styleWrapper);
        return globalFragment;
      }

      styleElement.innerHTML = `:root { ${stringifyCssVariables(cssVariables)} }`;
      return globalFragment;
    },
    false
  );

const setCustomGlobalStylesVariables = (cssVariables, updateStrategy = UPDATE_BOTH) => {
  const store = connectedStore.get();
  const state = store.getState();
  const variables = template.selectors.getVariables(state);

  const { id, globalId } = variables[GLOBAL_STYLES_VARIABLE][0];

  const headerCodeGlobal = globals.selectors.getGlobal(state, globalId);

  switch (updateStrategy) {
    case UPDATE_LIVE_ONLY: {
      updateLiveCssVariables(headerCodeGlobal, id, cssVariables);
      break;
    }
    case UPDATE_STATIC_ONLY:
      updateStaticCssVariables(globalId, id, cssVariables);
      break;
    case UPDATE_BOTH: {
      updateLiveCssVariables(headerCodeGlobal, id, cssVariables);
      updateStaticCssVariables(globalId, id, cssVariables);
      break;
    }
  }
};

export default setCustomGlobalStylesVariables;
